module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Top', {
    attrs: {
      "title": "Задания",
      "subtitle": "Проверочные задания для выполнения."
    }
  }, [(_vm.isLoading) ? _c('LoadingSpinner', {
    attrs: {
      "size": 100
    }
  }) : [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": "Ошибка"
    }
  }) : [(_vm.data.length) ? _c('Info', {
    attrs: {
      "id": _vm.id,
      "items": _vm.data
    }
  }) : _c('Warning', {
    attrs: {
      "isHeader": false
    }
  }, [_c('p', [_vm._v("На данный момент проверочных работ нет.")])])]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e4f0813","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/tests/Tests.vue
// module id = 539968a75a9dc21763b6
// module chunks = 24